import { render, staticRenderFns } from "./addcol.vue?vue&type=template&id=d73b328e&scoped=true"
import script from "./addcol.vue?vue&type=script&lang=js"
export * from "./addcol.vue?vue&type=script&lang=js"
import style0 from "./addcol.vue?vue&type=style&index=0&id=d73b328e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73b328e",
  null
  
)

export default component.exports